import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class EditionAPI {
    constructor() {
        this.baseUrl = new URL("bussched/edition/", apiBusSchedBaseURL);
    }

    getNetworks() {
        const url = new URL("network", this.baseUrl);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}